import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Routes } from '../../definitions/routes';

export const HISTORICO_AUTORIZACOES = 'historico-autorizacoes';

export function setupAutorizacao(): void {
  const modules = [{
    entry: HISTORICO_AUTORIZACOES,
    id: HISTORICO_AUTORIZACOES,
    name: `beneficiary.${HISTORICO_AUTORIZACOES}`,
    route: Routes.HISTORICO_AUTORIZACOES,
    order: 1,
    closeable: true,
  }];

  applicationModuleRegistry.registerGroup({
    entry: 'autorizacao',
    id: 'autorizacao',
    name: 'beneficiary.autorizacao',
    modules,
    order: 7,
  });
}
